import { all, put, select, takeLatest } from 'redux-saga/effects';
import { requests, actions } from './reducer';
import { getProjectListQuery } from './selector';

export function* fetchEffect({ payload }) {
  const actualQuery = yield select(getProjectListQuery);
  const query = {
    ...actualQuery,
    ...payload,
  };
  yield put(
    requests.fetch({
      report: '/warranties/building',
      query,
    }),
  );
}

export default function* () {
  yield all([takeLatest(actions.setFilter.type, fetchEffect)]);
}
